module.exports = __webpack_public_path__ + "static/media/FreeSan-01.26265b2b.svg";